import { render, staticRenderFns } from "./EmployeeForm.vue?vue&type=template&id=1bece256&scoped=true"
import script from "./EmployeeForm.vue?vue&type=script&lang=js"
export * from "./EmployeeForm.vue?vue&type=script&lang=js"
import style0 from "./EmployeeForm.vue?vue&type=style&index=0&id=1bece256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bece256",
  null
  
)

export default component.exports